import { useState, type CSSProperties } from 'react';
import { PhinAvatarLazy } from '@belong/ai-pointer';
import classNames from 'classnames/bind';
import styles from './phin-celebration.module.css';

const cx = classNames.bind(styles);

const AVATAR_SIZE = 48;

const PIECES = [
  { color: '#3ee4a9', dx: -30, rise: -34, fall: 6, spin: 200, delay: 0 },
  { color: '#6ddeef', dx: -16, rise: -44, fall: 4, spin: -160, delay: 0.3 },
  { color: '#ffb4b4', dx: 4, rise: -50, fall: 2, spin: 240, delay: 0.1 },
  { color: '#ffd479', dx: 20, rise: -42, fall: 8, spin: -220, delay: 0.5 },
  { color: '#b98cff', dx: 34, rise: -30, fall: 10, spin: 180, delay: 0.2 },
  { color: '#3ee4a9', dx: 10, rise: -38, fall: 6, spin: -200, delay: 0.7 },
  { color: '#ff8a8a', dx: -24, rise: -26, fall: 12, spin: 260, delay: 0.9 },
  { color: '#6ddeef', dx: 28, rise: -48, fall: 4, spin: 140, delay: 1.1 },
  { color: '#ffd479', dx: -8, rise: -52, fall: 8, spin: 210, delay: 1.3 },
  { color: '#b98cff', dx: -34, rise: -40, fall: 14, spin: -180, delay: 0.4 },
  { color: '#ff8a8a', dx: 16, rise: -34, fall: 10, spin: 230, delay: 1.5 },
  { color: '#3ee4a9', dx: 38, rise: -44, fall: 6, spin: -150, delay: 0.8 },
  { color: '#ffb4b4', dx: -20, rise: -46, fall: 2, spin: 170, delay: 1.7 },
  { color: '#6ddeef', dx: 0, rise: -32, fall: 12, spin: -240, delay: 1.9 },
];

const JUMP_EVERY_MS = 7000;

export function PhinCelebration() {
  const [burst, setBurst] = useState(0);
  return (
    <div className={cx('stage')} aria-hidden>
      {PIECES.map((piece) => (
        <span
          key={`${burst}-${piece.dx}-${piece.delay}`}
          className={cx('piece')}
          style={
            {
              background: piece.color,
              animationDelay: `${piece.delay}s`,
              '--dx': `${piece.dx}px`,
              '--rise': `${piece.rise}px`,
              '--fall': `${piece.fall}px`,
              '--spin': `${piece.spin}deg`,
            } as CSSProperties
          }
        />
      ))}
      <PhinAvatarLazy
        size={AVATAR_SIZE}
        interactive={false}
        idleJumps={false}
        jumpEveryMs={JUMP_EVERY_MS}
        onJump={() => setBurst((count) => count + 1)}
      />
    </div>
  );
}
